import { Action } from "./Action.js";
import { getElementByIdInContext } from "../lib/utils.js";

/**
 * @class OpenWindow
 * @extends Action
 * @classdesc Действие Открыть окно
 * */
export class OpenWindow extends Action {
    execute(context) {
        if (!this.WindowID) {
            $ns.add({
                type: "warning",
                time: new Date().toLocaleString(),
                title: i18next.t("title_window_not_found"),
                text: i18next.t("window_not_found"),
            });
            return;
        }

        if ($pm.hasPermissions) {
            const targetContext = context.currentTarget || context.target;
            $pm.resolveOpenWindow(
                targetContext,
                this.WindowID,
                this.ObjectId,
                this.continueExecution.bind(this, context)
            );
        } else {
            this.continueExecution(context);
        }
    }
    continueExecution(context) {
        const winModel = this.createWinModel();
        if (this.OpenNew == true) {
            window.open(this.createUrl(winModel), "_blank", this.createFeatures(winModel));
            return;
        }

        const frame = this.FrameID
            ? getElementByIdInContext(this.context, this.FrameID)
            : document.querySelector("ms-frame");
        const win = frame.openWindow(winModel);
        this.msWin = win;

        if (this.parameters) {
            for (const key in this.parameters) {
                win.SetParameter(
                    key.toLowerCase(),
                    this.calcParam(this.parameters[key], context)
                );
            }

            if (this.prop_link) {
                const keys = Object.keys(this.prop_link);
                for (let index = 0; index < keys.length; index++) {
                    let key = keys[index].toLowerCase();
                    if (key in win) {
                        let oldLink = this.msWin.propLink[key];
                        if (oldLink) {
                            this.msWin.AddLinkCallback(
                                key,
                                (
                                    element,
                                    linkUp,
                                    value,
                                    attrName,
                                    itemIndex
                                ) => {
                                    oldLink(
                                        element,
                                        linkUp,
                                        value,
                                        attrName,
                                        itemIndex
                                    );
                                    this.LinkUp(
                                        element,
                                        linkUp,
                                        value,
                                        attrName,
                                        itemIndex
                                    );
                                }
                            );
                        } else
                            this.msWin.AddLinkCallback(
                                key,
                                this.LinkUp.bind(this)
                            );
                    }
                }
            }
        }
    }

    createWinModel() {
        const windDef = $WinDefs.winDef[this.WindowID];

        const { objectid, taskid, outerpath } =
            windDef.objectid === "0"
                ? $sw.ItemSubscription.GetInstanceFields(this)
                : windDef;

        return {
            ...windDef,
            ...(objectid ? { objectid } : {}),
            ...(taskid ? { taskid } : {}),
            ...(outerpath ? { outerpath } : {}),
        };
    }

    createUrl(windModel) {
        const props = ["objectid", "taskid", "outerpath"];
        return props.reduce((acc, val) => {
            const prop = windModel[val];
            return prop && prop !== "0"
                ? `${acc}&${val}=${windModel[val]}`
                : acc;
        }, `?${this.WindowID}`);
    }

    createFeatures(winModel) {
        const params = this.parameters || {};
        const lowerCaseKeysParams = Object.keys(params).reduce((acc, key) => {
            acc[key.toLowerCase()] = params[key];
            return acc;
        }, {});
        const winProps = ["width", "height", "x", "y"];
        return winProps.reduce((acc, val) => {
            const prop = lowerCaseKeysParams[val] ?? winModel[val] ?? 0;
            return `${acc},${val}=${prop}`;
        }, "");
    }

    get WindowID() {
        return typeof this._WindowID === "undefined" ? "" : this._WindowID;
    }
    set WindowID(value) {
        if (value.toString().includes(".")) {
            this._WindowID = $pr.getWindowIdByPath(value);
            if (
                typeof $WinDefs.winDef[this._WindowID] !== "undefined" &&
                $WinDefs.winDef[this._WindowID].objectid === "0"
            ) {
                const { objectid, outerpath } = $pr.getObjectIdByPath(value);
                this.ObjectId = objectid;
                this.FullOuterPath = outerpath;
            }
        } else {
            this._WindowID = value;
        }
    }

    get FrameID() {
        return typeof this._FrameID === "undefined" ? "" : this._FrameID;
    }
    set FrameID(value) {
        if (value.toString().includes(".")) {
            this._FrameID = $pr.getWindowIdByPath(value);
        } else {
            this._FrameID = value;
        }
    }

    UpdateParameters(PropertyPath, value) {
        if (this.msWin && this.parameters_bychange?.[PropertyPath])
            this.msWin.SetParameter(PropertyPath.toLowerCase(), value);
        this.parameters[PropertyPath] = value;
    }
}
